module.exports = __webpack_public_path__ + "img/cabin-front.bee5da53.jpg";